import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error JS module
import UrlPattern from 'PatternValidationJS/patterns/Url';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Form } from 'foundations-components/transitional/components/Form';
import { useMutation } from 'data-fetching-client';
import { useReducer, useState } from 'react';
import { push } from '../../actions/HistoryActions';
import { SCREENS } from '../../constants/TrackingConstants';
import { useCurrentKnowledgeBaseId } from '../../knowledge-base/hooks/knowledgeBaseHooks';
import { getArticlesPath } from '../../routing/utils/internalPaths';
import UsageTracker from '../../utils/UsageTracker';
import { useAppDispatch } from '../../utils/hooks';
import { MODAL_WIDTH } from '../../constants/ModalConstants';
import ImportTypeInput, { ImportTypes } from '../components/ImportTypeInput';
import KBSelect from '../components/KBSelect';
import UrlInput from '../components/UrlInput';
import { START_SMART_COPY } from '../queries';

// #region Error Reducer
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function reducer(state, action) {
  switch (action.type) {
    case 'CLEAR_ERROR':
      return Object.assign({}, state, {
        errorKey: undefined
      });
    case 'INVALID_URL':
      return Object.assign({}, state, {
        errorKey: 'knowledgeContentUI.importModal.urlInput.errors.invalidUrl'
      });
    case 'SET_URL':
      return {
        errorKey: undefined,
        url: action.url
      };
    case 'UNSUPPORTED_KB':
      return Object.assign({}, state, {
        errorKey: 'knowledgeContentUI.importModal.urlInput.errors.notSupported'
      });
    case 'UNKNOWN_ERROR':
      return Object.assign({}, state, {
        errorKey: 'knowledgeContentUI.importModal.urlInput.errors.unknown'
      });
    default:
      return state;
  }
}
// #endregion

const ImportModal = ({
  onClose
}) => {
  const currentKBId = useCurrentKnowledgeBaseId();
  const dispatch = useAppDispatch();
  const [selectedKBId, setSelectedKBId] = useState(currentKBId);
  const [importTypeInput, setImportTypeInput] = useState(ImportTypes.DRAFT);
  const [{
    errorKey,
    url
  }, dispatchState] = useReducer(reducer, {
    errorKey: undefined,
    url: ''
  });
  const [startSmartCopy, {
    loading: isLoading
  }] = useMutation(START_SMART_COPY);
  const handleUrlInputChange = event => {
    dispatchState({
      type: 'SET_URL',
      url: event.currentTarget.value
    });
  };
  const handleFormSubmit = e => {
    e.preventDefault();
    if (!UrlPattern.test(url)) {
      dispatchState({
        type: 'INVALID_URL'
      });
      return;
    }
    UsageTracker.track('importInteraction', {
      action: 'button-click',
      screen: SCREENS.MANAGE
    });
    dispatchState({
      type: 'CLEAR_ERROR'
    });
    startSmartCopy({
      variables: {
        autoPublish: importTypeInput === ImportTypes.PUBLISH,
        knowledgeBaseId: selectedKBId,
        url
      }
    }).then(() => {
      dispatch(push(getArticlesPath(selectedKBId)));
      onClose();
    }).catch(error => {
      var _error$networkError;
      if (((_error$networkError = error.networkError) === null || _error$networkError === void 0 ? void 0 : _error$networkError.status) === 400) {
        dispatchState({
          type: 'UNSUPPORTED_KB'
        });
      } else {
        dispatchState({
          type: 'UNKNOWN_ERROR'
        });
      }
    });
  };
  return /*#__PURE__*/_jsx(Modal, {
    size: "auto",
    width: MODAL_WIDTH,
    children: /*#__PURE__*/_jsxs(Form, {
      onSubmit: handleFormSubmit,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.importModal.header"
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "knowledgeContentUI.importModal.message"
        }), /*#__PURE__*/_jsx(UrlInput, {
          disabled: isLoading,
          errorKey: errorKey,
          onChange: handleUrlInputChange,
          value: url
        }), /*#__PURE__*/_jsx(KBSelect, {
          disabled: isLoading,
          onChange: setSelectedKBId,
          value: selectedKBId
        }), /*#__PURE__*/_jsx(ImportTypeInput, {
          disabled: isLoading,
          onChange: event => setImportTypeInput(event.target.value),
          value: importTypeInput
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(LoadingButton, {
          disabled: !url || selectedKBId === null || Boolean(errorKey),
          loading: isLoading,
          type: "submit",
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.importModal.buttons.import"
          })
        }), /*#__PURE__*/_jsx(Button, {
          disabled: isLoading,
          onClick: onClose,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.importModal.buttons.cancel"
          })
        })]
      })]
    })
  });
};
export default ImportModal;